import { EQUIPMENT_KINDS } from 'shared/constants';

export const selectEquipmentState = state => state.equipment;
export const selectEquipment = state => state.equipment.equipments;
export const selectPDUs = state =>
  state.equipment.equipments.filter(
    equipment => equipment.type.kind === EQUIPMENT_KINDS.PDU
  );
export const selectASICs = state =>
  state.equipment.equipments.filter(
    equipment => equipment.type.kind === EQUIPMENT_KINDS.ASIC
  );
export const selectEquipmentById = (state, id) =>
  state.equipment?.equipments?.find(equipment => equipment.id === id);
export const selectEquipmentTypes = state => state.equipment.equipmentTypes;
export const selectPSUsTypes = state =>
  state.equipment.equipmentTypes.filter(
    equipmentType => equipmentType.kind === EQUIPMENT_KINDS.PDU
  );
export const selectASICsTypes = state =>
  state.equipment.equipmentTypes.filter(
    equipmentType => equipmentType.kind === EQUIPMENT_KINDS.ASIC
  );
export const selectEquipmentIsLoading = state => state.equipment.isLoading;
export const selectEquipmentError = state => state.equipment.error;
